import React, { useEffect, useState } from "react";
import Select from "react-select";

const url = "https://tec.utpl.edu.ec";
const OfferTec = () => {
  const [carreras, setCarreras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [facultad, setFacultad] = useState({
    value: "todos",
    label: "Toda la oferta",
  });

  useEffect(() => {
    fetch("https://tec.utpl.edu.ec/tec-periodo-1")
      .then((response) => response.json())
      .then((data) => {
        setCarreras(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar las carreras:", error);
        setLoading(false);
      });
  }, []);

  const renderHTML = (htmlString) => (
    <span dangerouslySetInnerHTML={{ __html: htmlString }} />
  );

  const optionsFacultad = [
    { value: "todos", label: "Toda la oferta" },
    {
      value: "Ciencias Económicas y Empresariales",
      label: "Ciencias Económicas y Empresariales",
    },
    {
      value: "Ciencias Exactas y Naturales",
      label: "Ciencias Exactas y Naturales",
    },
    {
      value: "Ciencias Sociales, Educación y Humanidades",
      label: "Ciencias Sociales, Educación y Humanidades",
    },
    {
      value: "Ciencias Jurídicas y Políticas",
      label: "Ciencias Jurídicas y Políticas",
    },
    {
      value: "Ingenierías y Arquitectura",
      label: "Ingenierías y Arquitectura",
    },
  ];

  const handleChangeFacultad = (selected) => {
    setFacultad(selected);
  };

  // Filtrado por facultad
  const carrerasFiltradas =
    facultad && facultad.value !== "todos"
      ? carreras.filter((carrera) =>
          carrera.field_area
            .toLowerCase()
            .includes(facultad.value.toLowerCase()),
        )
      : carreras;

  if (loading) {
    return <p className="text-center py-10">Cargando...</p>;
  }

  function IsPeriodo(data) {
    if (data && data.trim && data.trim() !== "") {
      return (
        <p>
          <b>Periodo:</b> {data}
        </p>
      );
    }
    return null; // Renderiza nada si data está vacío
  }

  return (
    <div>
      <div className="bloque2">
        <div className="wrapper-academicoffer ">
          {carrerasFiltradas.map((carrera, index) => (
            <div key={index}>
              <div className="programa-imagen ">
                <img
                  src={url + carrera.field_imagen_template}
                  alt={carrera.title}
                />
              </div>

              <div className="layout8">
                <h3>{carrera.title}</h3>
                <p>
                  <strong>Modalidad:</strong> {carrera.field_modalidad}
                </p>
                <p>
                  <strong>Duración:</strong> {carrera.field_duracion}
                </p>

                {IsPeriodo(carrera.field_periodo)}

                <div className="wrapper-link">
                  <a
                    className="link-offer "
                    href={carrera.field_enlace_contenido}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Ver programa
                    <span className="material-icons text-sm">
                      arrow_forward_ios
                    </span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OfferTec;
